import { Routes } from '@angular/router';
import { provideRouter } from '@angular/router';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { ChatbotAgentComponent } from './chatbot_agent/chatbot_agent.component';
// import { TextToSpeechComponent } from './testing/text-to-speech.component';

export const routes: Routes = [
    { path: '', component: ChatbotComponent }, // Default route
    { path: 'ai_agent', component: ChatbotAgentComponent }
    //{ path: "ttos", component: TextToSpeechComponent }
  ];

export const appRouting = provideRouter(routes);
